import { PaymentConfirmationError } from "./errors/PaymentConfirmationError";
import { PaymentOrchestrationError } from "./errors/PaymentOrchestrationError";

/**
 * Checks if an error is a PaymentConfirmationError
 *
 * Payment confirmation errors are handled differently as they are not really "errors"
 * that we need to be worried about. So they shouldn't affect things like metrics and monitoring.
 */
export function isPaymentConfirmationError(
  error: unknown
): error is PaymentConfirmationError {
  return error instanceof PaymentConfirmationError;
}

/**
 * Utility function to check if an error is a payment orchestration error
 * This should only be used within the payments module.
 */
export function isPaymentOrchestrationError(
  error: unknown
): error is PaymentOrchestrationError {
  return error instanceof PaymentOrchestrationError;
}

/**
 * Extracts user-friendly error messages for display in UI toasts.
 * For PaymentOrchestrationError, uses the userMessage property.
 * For other errors, falls back to generic messages.
 */
export function getPaymentErrorMessage(error: unknown): string {
  if (isPaymentOrchestrationError(error)) {
    return error.userMessage; // User-friendly message for UI display
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Something went wrong with your payment. Please try again.";
}
